export type HTMLRocheImageElementExtended = HTMLRocheImageElement & {
  imageElementHeight: number;
  playVideo: () => void;
  pauseVideo: () => void;
  seekTo: (_: number) => void;
  /**
   * Warning: Calling reinitialize reduces performance. Use as a last resort.
   * On edge cases, Stencil's loader may instatiate parent components
   * AFTER all child roche-image components.
   * When in this context, call reinitialize from the parent to ensure proper roche-image rendering.
   */
  reinitialize: () => void;
}

export enum Ratio {
  HD = '16:9',
  WIDE = '2.39:1',
  SQUARE = '1:1',
  VERTICAL = '4:5',
  ORIGINAL = 'original',
  // The 4:3 aspect ratio is for dev use only. Editors should not be able to select it.
  NORMAL = '4:3',
  SIXTOFIVE = '6:5',
}

export const ratioKeys = Object.keys(Ratio);
export const ratioValues = ratioKeys.map((ratio) => Ratio[ratio]);

export enum Position {
  TOP = 'top',
  CENTER = 'center',
  BOTTOM = 'bottom',
}

export const positionKeys = Object.keys(Position);
export const positionValues = positionKeys.map((position) => Position[position]);

export interface RocheImageProp {
  src: string;
  caption?: string;
  copyright?: string;
  alt?: string;
  title?: string;
}

export enum WidthGetterAlgorithm {
  // Uses the displayed Width: https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
  WITH_TRANSFORM,
  // Uses the original Width: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetWidth
  WITHOUT_TRANSFORM
}

export enum ImageEvents {
  IMAGE_HEIGHT_UPDATED = 'image-height-updated'
}
